import { styled } from "@mui/material/styles";

export const CursorLoadingContainer = styled("div")(({ theme }) => ({
    display: "flex",
    minHeight: theme.space._1400,
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "stretch",

    pointerEvents: "auto",
    cursor: "progress",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));